import { NotePencilSVG } from 'common/assets';
import { NavigationRoutes } from 'common/constants';
import { IconButton } from 'components/elements/buttons';
import useDrawer from 'hooks/use-drawer';
import useNavigation from 'hooks/use-navigation';
import React from 'react';

import TransactionalFootnoteDrawer from '../components/transactional-footnote-drawer';

export type TransactionalRowType = {
  arNumberKey: string;
  customerKey: string;
  numberKey: string;
  codeKey: string;
  transactionAtKey: string;
  dueDateKey: string;
  arNumber: string;
  customer: string;
  number: string;
  code: null;
  transactionAt: string;
  dueDate: string;
  amount: string;
  discount: string;
  cost: number;
  total: number;
  label: null;

  position: null;
};

export default function useTransactionalFootnoteDrawer() {
  const { activeKey } = useNavigation();

  const drawer = useDrawer();

  const transactionalType = React.useMemo(() => {
    switch (activeKey) {
      case NavigationRoutes.AccountPayableReport:
      case NavigationRoutes.AccountPayableRegularReport:
        return 'purchases';
      case NavigationRoutes.AccountReceivableReport:
      case NavigationRoutes.AccountReceivableRegularReport:
        return 'sales';
      default:
        return undefined;
    }
  }, [activeKey]);

  const onClickTransactional = React.useCallback(
    (row: TransactionalRowType) => () => {
      if (!transactionalType) return;

      return drawer.showCustom({
        render(close) {
          return (
            <TransactionalFootnoteDrawer
              id={row.numberKey}
              number={row.number}
              type={transactionalType}
              onClose={close}
            />
          );
        },
      });
    },
    [drawer, transactionalType],
  );

  const transactionalButton = React.useCallback(
    (row: TransactionalRowType, accessorKey: string) => {
      if (!transactionalType) return;
      if (row.label) return;
      if (accessorKey !== 'number') return;

      return (
        <div
          key={row.arNumber}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'start',
          }}
        >
          {row.number}
          <IconButton
            overrides={{
              Root: {
                style: {
                  padding: '0px',
                  borderRadius: '4px',
                },
              },
            }}
            buttonType="tertiary"
            onClick={onClickTransactional(row)}
          >
            <NotePencilSVG color="#5D7B9F" size={20} />
          </IconButton>
        </div>
      );
    },
    [onClickTransactional, transactionalType],
  );

  return {
    onClickTransactional,
    type: transactionalType,
    transactionalButton,
  };
}
